import { useEffect } from 'react';
import { useDispatch } from 'react-redux';

import { Size as ScreenSize } from '@swf/core/enums';
import useScreenSize from '@swf/core/hooks/useScreenSize';
import type { Dispatch } from '@swf/core/store';

/**
 * Automatically sets the context for betSlip open to true if the receipt is rendered on mobile
 * after placing a bet
 */
const useOpenReceiptOnMobile = () => {
  const { betSlip } = useDispatch<Dispatch>();
  const { greaterThan } = useScreenSize();
  const isMobile = !greaterThan(ScreenSize.Small);

  useEffect(() => {
    if (isMobile) betSlip.betSlipOpened(true);
  }, [isMobile, betSlip]);
};

export default useOpenReceiptOnMobile;
